// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ti-z","heading":"Ui-z","items":"Vi-z","featureCss":"Wi-z","disabled":"Xi-z","imgCss":"Yi-z"};